import { useEffect, useState } from 'react';

/**
 * Custom hook that determines if the component has been hydrated.
 *
 * This hook sets an `isHydrated` state to `true` after the component has been mounted.
 * It can be used to conditionally render content that depends on client-side hydration.
 *
 * @returns `true` if the component has been hydrated, otherwise `false`.
 */
export const useIsHydrated = (): boolean => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return isHydrated;
};
